import {getV1PostId} from '../../common/util';

import {BaseService} from './base';


export class CacheService extends BaseService {
    internalCache: Record<string, Record<string, boolean>>;

    constructor(context: jsx.AppGlobals) {
        super(context, {});
        this.internalCache = {};
        this.internalCache['userFavorites'] = this.storedFavorites() || {};
    }
    storedFavorites() {
        const storedFavoritesItem = this.context.storageService.getItem(
            'userFavorites');
        if (storedFavoritesItem) {
            return JSON.parse(storedFavoritesItem);
        } else {
            return false;
        }
    }
    isFavorite(gif: api.Post) {
        const pid = getV1PostId(gif) || '';
        const userFavorites = this.internalCache['userFavorites'];
        if (userFavorites) {
            return userFavorites[pid] !== undefined ||
                userFavorites[gif.id] !== undefined;
        } else {
            return false;
        }
    }
    getFavorites() {
        return this.internalCache['userFavorites'];
    }
    updateFavorites(pids: string|string[], remove: boolean) {
        pids = (Array.isArray(pids) ? pids : [pids]);

        pids.forEach((pid: string, i: number) => {
            if (remove) {
                delete this.internalCache['userFavorites'][pid];
            } else {
                this.internalCache['userFavorites'][pid] = true;
            }
        });
        this.context.storageService.setItem('userFavorites',
            JSON.stringify(this.internalCache['userFavorites']));
    }
    setFavorites(favList: Record<string, boolean>) {
        this.internalCache['userFavorites'] = favList;
        this.context.storageService.setItem('userFavorites',
            JSON.stringify(this.internalCache['userFavorites']));
    }
    clearFavorites() {
        this.internalCache['userFavorites'] = {};
        this.context.storageService.removeItem('userFavorites');
    }
}
